import React, { useRef, useEffect } from 'react'
import Card from '@material-ui/core/Card'
import CardContent from '@material-ui/core/CardContent'
import Typography from '@material-ui/core/Typography'
import { ArrowDown, ArrowUp } from 'lib/lucide'

interface CardProperties {
  value: number | undefined
  description: string | undefined
  value_previous: number | undefined
  isPercent: boolean | undefined
  isCurrency?: boolean
}

const getPercentageIncrease = (
  value: number,
  value_previous: number,
  isPercent: boolean,
  isCurrency = false,
) => {
  const percentage = ((value - value_previous) / value_previous) * 100
  if (isCurrency) {
    return isPercent ? `${percentage.toFixed(2)}%` : formatValue(value - value_previous, true)
  }
  return isPercent ? `${percentage.toFixed(2)}%` : `${value - value_previous}`
}

const formatValue = (value: number | undefined, isCurrency = false) => {
  if (!value) return '0'
  if (isCurrency) {
    return new Intl.NumberFormat('es-UY', {
      style: 'currency',
      currency: 'UYU',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(value)
  }
  return value.toString()
}

const CardDashboad: React.FC<CardProperties> = ({
  value,
  description,
  value_previous,
  isPercent = false,
  isCurrency = false,
}) => {
  const textRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const adjustFontSize = () => {
      if (textRef.current) {
        const container = textRef.current
        const text = container.textContent || ''
        const containerWidth = container.offsetWidth
        const fontSize = Math.min(40, containerWidth / (text.length * 0.6))
        container.style.fontSize = `${fontSize}px`
      }
    }

    adjustFontSize()
    window.addEventListener('resize', adjustFontSize)
    return () => window.removeEventListener('resize', adjustFontSize)
  }, [value])

  return (
    <>
      <Card>
        <CardContent>
          <Typography
            variant="h3"
            component="h3"
            align="center"
            ref={textRef}
            style={{
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              width: '100%',
            }}
          >
            {formatValue(value, isCurrency)}
          </Typography>
          <Typography color="textSecondary" align="center">
            {value ? description : 'No hay nada todavía.'}
          </Typography>
          <Typography align="center">
            {value_previous && value && value >= value_previous ? (
              <ArrowUp size={18} style={{ color: 'green', verticalAlign: 'sub' }} />
            ) : (
              value_previous &&
              value && <ArrowDown size={18} style={{ color: 'red', verticalAlign: 'sub' }} />
            )}
            {value_previous && value
              ? getPercentageIncrease(value, value_previous, isPercent, isCurrency)
              : ''}
          </Typography>
        </CardContent>
      </Card>
    </>
  )
}

export { CardDashboad }
